import { Injectable } from '@angular/core';
import { SerialSearchResponseResultDto } from '../serial-search/serial-search-response.dto';
import { SerialSearchService } from '../serial-search/serial-search.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceEligibilityService {

  public constructor(
    private serialSearchService: SerialSearchService,
  ) { }

  /**
   * This method returns true when the device indicated by the incoming
   * SerialSearchResponseResultDto results is eligible for coverage by considering
   * only the knowledge that comes from the data of the incoming
   * SerialSearchResponseResultDto object.
   * 
   * Part of this check is to check if the IMEI is blacklisted; a blacklisted IMEI is
   * not eligible for coverage. Other GSMA and FMIP checks are done as well and are
   * part of the final result. Additionally it checks to make sure that the equipment
   * list only contains items related to the given IMEI / serial number.
   * 
   * @param serialSearchResults The results of looking up the device using the
   * SerialSearchService. These results are expected to be the results from looking
   * up the device by its IMEI.
   */
  public doesSerialSearchResultHaveDeviceThatIsEligibleForCoverage(serialSearchResults: SerialSearchResponseResultDto): boolean {
    if (serialSearchResults == null) {
      return false;
    }

    // Our assumption is that if it couldn't communicate with GSMA then we are returning false meaning it is not eligible. (meaning if transactionEligible is "Unknown" then that is not eligible)
    // It also is in eligible when the device wasn't found by GSMA, like if the equipment list inside the results isn't specific to the searched IMEI, then the device must not have been found by GSMA and so we return false indicating that it isn't eligible.
    return 'Yes' === serialSearchResults.transactionEligible
      && this.serialSearchService.doesEquipmentListIncludeOnlyResultsForGivenImei(serialSearchResults);
  }
}
